import i18n from "i18next";
import * as yup from "yup";

import { Shape } from "@/core/yup";

import { FormDateRange } from "./DateRangeForm";

export const formSchema = () =>
    yup.object<{}, Shape<FormDateRange>>({
        dateFrom: yup.date().required().presentOrPast().nullable(),
        dateUntil: yup
            .date()
            .presentOrPast()
            .min(yup.ref("dateFrom"), i18n.t("Validations.DateAfterDateFrom"))
            .nullable(),
    });
